module.exports = __webpack_public_path__ + "static/media/jcb.d9e3ece1.jpg";